import { Stack, useLocalSearchParams } from 'expo-router';
import { ScrollView } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { useQuery } from 'urql';
import Text from '@/components/UI/Text';
import { graphql } from '@/gql/graphql';

const GetEventNoteDetail = graphql(/* GraphQL */ `
  query GetEventNoteDetail($eventId: uuid!) {
    event_by_pk(id: $eventId) {
      id
      notes
    }
  }
`);

export default function EventNoteDetail() {
  const { eventId } = useLocalSearchParams<{ eventId?: string }>();

  const [{ data }] = useQuery({
    query: GetEventNoteDetail,
    variables: { eventId: eventId || '' },
    pause: !eventId,
  });

  const event = data?.event_by_pk;

  return (
    <>
      <Stack.Screen options={{ title: 'Notes' }} />
      <ScrollView contentContainerStyle={styles.scrollView}>
        <Text selectable size="md" style={styles.note}>
          {event?.notes || ''}
        </Text>
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    padding: 12,
  },
  note: {
    userSelect: 'text',
  },
});
